import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {getUniversity} from '../api/university';
import {getUserApi} from '../api/users';

@Component({
  selector: 'dashboard-nav',
  templateUrl: './dashboard-nav.component.html',
  styleUrls: ['./dashboard-nav.component.css'],
})
export class DashboardNavbar implements OnInit {
  currentPage=""
  type=''
  constructor(private router:Router,private cd:ChangeDetectorRef) {
    router.events.subscribe(event => {

      if (event instanceof NavigationEnd ) {
        this.currentPage=event.url


      }
    });

  }

name=''
uniName=''
uniLogo=''
adminPhoto=''
  ngOnInit() {
  this.name=localStorage.getItem('name')
  this.type=localStorage.getItem('type')
  this.uniName=localStorage.getItem('uniName')
  this.uniLogo=localStorage.getItem('uniLogo')
  this.adminPhoto=localStorage.getItem('admin_photo')


this.getUser()
    this.getUni()
  }


  async getUni(){
    let id=localStorage.getItem('uni')
    const result = await getUniversity(id);
    console.log(localStorage)
    console.log(result)
    if(result){
      this.uniName=result.data.data.ar_name
      this.uniLogo=result.data.data.logo
      localStorage.setItem('uniName',this.uniName)
      localStorage.setItem('uniLogo',this.uniLogo)
      this.cd.detectChanges()
    }

  }
  async getUser(){
    let id=localStorage.getItem('_id')
    const result = await getUserApi(id);
    if(result){
      this.name=result.data.data.name
      this.adminPhoto=result.data.data.profile_photo

      localStorage.setItem('name',this.name)
      localStorage.setItem('admin_photo',this.adminPhoto)

      this.cd.detectChanges()
    }

  }
  logout() {

    localStorage.clear()
    this.router.navigateByUrl('/login')

  }


}
